import { useCallback, useEffect, useState } from 'react'
import { ModalLittle } from '../../../../../../baseComponents/Modal'
import { ModalComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { WorkSheetProductModelType } from '@teinor/erp/types/company/order/sell/workSheet/workSheetProduct'
import { ButtonPrimary } from '../../../../../../baseComponents/Button'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { useNavigate } from 'react-router'
import locations from '../../../../../../utils/globals/locations'
import ITHeaderText from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface ModalWorkSheetStatusOrderProductProps extends ModalWorkSheetStatusOrderProductLogicProps { }

const ModalWorkSheetStatusOrderProduct: React.FC<ModalWorkSheetStatusOrderProductProps> = ({ setOpened, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { productStatus } = useModalWorkSheetStatusOrderProductLogic({ setOpened, allRowData, ...rest })
    const navigate = useNavigate()
    const renderThis: JSX.Element[] = []
    if (productStatus?.length) {
        for (const element of productStatus) {
            renderThis.push(
                <div className='flex gap-30 mb-20'>
                    <ITHeaderText label={t('quantity', 'Cantidad')} value={String(element.quantity)} className='w-100' />
                    <ITWorkSheetStatusText label={t('status', 'Estado')} value={element.WorkSheetProductStatus?.name || ''} className='w-150' color={element.WorkSheetProductStatus?.color || ''} />
                    <ITHeaderText label={t('quantityProcessedS', 'Cant. procesada')} value={String(element.alreadyOrderProcessed)} className='w-150' />
                </div>
            )
        }
    }
    return (
        <ModalLittle opened={true} setOpened={setOpened} className='flex flex-col flex-auto'>
            <h4 className='mb-30'>{allRowData?.reference} - {allRowData?.name}</h4>
            <div className='flex flex-auto flex-col'>
                {renderThis}
            </div>
            {allRowData?.WorkSheetId ? <ButtonPrimary className='ml-auto ' onClick={() => navigate(locations.workSheetSingle + '/' + allRowData?.WorkSheetId)}><TwinTrans transKey='goToWorksheet'>Ir a la hoja de trabajo</TwinTrans></ButtonPrimary> : null}
        </ModalLittle>
    )
}

interface ModalWorkSheetStatusOrderProductLogicProps extends ModalComponentProps {
    allRowData?: RowData
}

const useModalWorkSheetStatusOrderProductLogic = ({ allRowData }: ModalWorkSheetStatusOrderProductLogicProps) => {
    const [productStatus, setProductStatus] = useState<WorkSheetProductModelType[] | null>(null)
    const getWorkSheetStatusProducts = useCallback(async () => {
        const workSheetIds = allRowData?.relatedWorkSheets || []
        if (allRowData?.WorkSheetId) {
            workSheetIds.push(allRowData?.WorkSheetId)
        }
        const result = await twinFetchPostJSON('/api/app/order/sell/workSheet/workSheetProduct/getAllWorkSheetProducts', {
            where: {
                WorkSheetId: { '$or': workSheetIds }, UniquePKSellProductId: allRowData?.UniquePKSellProductId
            }
        })
        if (result) {
            setProductStatus(result)
        }
    }, [allRowData, setProductStatus])

    useEffect(() => {
        getWorkSheetStatusProducts()
    }, [getWorkSheetStatusProducts])

    return { productStatus }
}

interface ITWorkSheetStatusTextProps {
    label: string
    value: string
    color: string
    className?: string
}

const ITWorkSheetStatusText: React.FC<ITWorkSheetStatusTextProps> = ({ label, value, className, color }) => {
    return (
        <div className={'flex flex-col ' + (className || '')}>
            <span className='light12 text-gray-51 mb-4'>{label}</span>
            <span className='flex items-center justify-center border rounded-5 px-10 text-center w-full py-1 twin_elipsis' style={{color}}>{value}</span>
        </div>
    )
}

export default ModalWorkSheetStatusOrderProduct